import { Injectable } from '@angular/core';
import { IMenuItem } from '../interfaces/menu-item';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class NavigationService {
  selectedItem: IMenuItem | undefined;
  defaultMenu: IMenuItem[] = [
    {
      id: 1,
      name: 'صفحه اصلی',
      title: 'Home',
      type: 'link',
      path: '',
      icon: 'assets/icon/menu-icon-mobile-5.svg',
      active: true,
      activeRoute: true,
    },
    {
      id: 2,
      name: 'ربات‌های تریدر',
      title: 'Store',
      type: 'dropdown',
      path: 'shop',
      icon: 'assets/icon/menu-icon-mobile-8.svg',
      active: true,
      activeRoute: true,
      iconDropDown: 'assets/icon/chevron-white.webp',
      sub: [
        {
          id: 1,
          name: 'ربات معامله‌گر ATM',
          parentID: 2,
          title: 'ATM Expert',
          type: 'link',
          path: `shop/atm-expert`,
          active: true,
          activeRoute: true,
        },
        {
          id: 2,
          name: 'ربات پراپ PropeX',
          parentID: 2,
          title: 'Prop Expert',
          type: 'link',
          path: `shop/propex-expert`,
          active: true,
          activeRoute: true,
        },
      ],
    },
    {
      id: 3,
      name: 'بروکرها',
      title: 'Brokers',
      type: 'dropdown',
      path: 'brokers',
      icon: 'assets/icon/menu-icon-mobile-3.svg',
      active: true,
      activeRoute: true,
      iconDropDown: 'assets/icon/chevron-white.webp',
      sub: [
        {
          id: 1,
          name: 'آمارکتس',
          parentID: 3,
          title: 'Brokers Amarkets',
          type: 'link',
          path: `brokers/amarkets/fa`,
          active: true,
          activeRoute: true,
        },
        {
          id: 2,
          name: 'لایت فایننس',
          parentID: 3,
          title: 'Brokers Litefinance',
          type: 'link',
          path: `brokers/lite-finance/fa`,
          active: true,
          activeRoute: true,
        },
        {
          id: 3,
          name: 'اپوفایننس',
          parentID: 3,
          title: 'Brokers Opofinance',
          type: 'link',
          path: `brokers/opofinance/fa`,
          active: true,
          activeRoute: true,
        },
      ],
    },
    {
      id: 4,
      name: 'پراپ‌فرم‌ها',
      title: 'propfirms',
      type: 'link',
      path: 'propfirms',
      icon: 'assets/icon/menu-icon-mobile-3.svg',
      iconDropDown: 'assets/icon/chevron-white.webp',
      active: true,
      activeRoute: true,
      sub: [
        {
          id: 1,
          name: 'فاندد نکست',
          parentID: 4,
          title: 'Propfirm FundedNext',
          type: 'link',
          path: `propfirms/fundednext-review/fa`,
          active: true,
          activeRoute: true,
        },
        {
          id: 2,
          name: 'زورا اِف‌ایکس',
          parentID: 4,
          title: 'PropFirm ZoraFX',
          type: 'link',
          path: `propfirms/zorafx-review/fa`,
          active: true,
          activeRoute: true,
        },
      ],
    },
    {
      id: 5,
      name: 'تقویم اقتصادی',
      title: 'Economic-Calendar',
      type: 'link',
      path: 'economic-calendar',
      icon: 'assets/icon/calendar.svg',
      active: true,
      activeRoute: true,
    },
    {
      id: 6,
      name: 'مدرسه ترید',
      title: 'Trade School',
      type: 'dropdown',
      icon: 'assets/icon/menu-icon-mobile-4.svg',
      active: true,
      activeRoute: false,
      iconDropDown: 'assets/icon/chevron-white.webp',
      sub: [
        {
          id: 1,
          path: 'expert-advisor',
          name: 'ربات‌های معامله‌گر',
          parentID: 6,
          title: 'Trading Robots',
          type: 'link',
          active: true,
          activeRoute: true,
        },
        {
          id: 2,
          path: 'money-management',
          name: 'مدیریت سرمایه',
          parentID: 6,
          title: 'Money Management',
          type: 'link',
          active: true,
          activeRoute: true,
        },
        {
          id: 3,
          path: 'prop-trading',
          name: 'پراپ تریدینگ',
          parentID: 6,
          title: 'Prop Trading',
          type: 'link',
          active: true,
          activeRoute: true,
        },
        {
          id: 4,
          name: 'کپی ترید',
          parentID: 6,
          title: 'copy-trade',
          path: 'copy-trade',
          type: 'link',
          // icon: 'assets/icon/menu-icon-mobile-11.webp',
          active: true,
          activeRoute: true,
        },
      ],
    },
    
    {
      id: 7,
      name: 'مقالات آموزشی',
      title: 'articles',
      type: 'link',
      path: 'articles',
      icon: 'assets/icon/menu-icon-mobile-6.svg',
      active: true,
      activeRoute: true,
    },

    /*
    {
      id: 7,
      name: 'مجله ایرانی اکسپرت',
      title: 'IRani Expert Magazine',
      type: 'dropdown',
      path: 'articles',
      icon: 'assets/icon/menu-icon-mobile-6.svg',
      active: true,
      activeRoute: true,
      sub: [
        {
          id: 1,
          path: 'articles',
          name: 'مقالات',
          parentID: 6,
          title: 'َArticles',
          type: 'link',
          active: true,
          activeRoute: true,
        },
      ],
    },
    */
    {
      id: 8,
      name: 'تماس با ما',
      title: 'contact-us',
      path: 'contact-us',
      type: 'link',
      icon: 'assets/icon/phone-icon-white.png',
      active: true,
      activeRoute: true,
    },
    {
      id: 9,
      name: 'چرا ما؟',
      title: 'about-us',
      path: 'about-us',
      type: 'link',
      icon: 'assets/icon/menu-icon-mobile-2.svg',
      active: true,
      activeRoute: true,
    },
  ];

  menuItems = new BehaviorSubject<IMenuItem[]>(this.defaultMenu);
  // navigation component has subscribed to this Observable
  menuItems$ = this.menuItems.asObservable();
}
